import {
  RangeSelector,
  useBottomControlsSectionCollapse,
} from "@rentablo/components";
import { RangeSelectorControlProps } from "@hooks";
import { CONSTRAINED_MAX_WIDTH } from "./constrainedWidth";

// Interval presets tables pass to CollapsibleRangeSelector (bookings, protocol…).
export const TABLE_INTERVAL_TYPES: IntervalType[] = [
  "oneMonth",
  "sixMonths",
  "oneYear",
  "sinceBeginning",
  "custom",
];

interface Props {
  rangeProps: RangeSelectorControlProps;
  intervalTypes?: IntervalType[];
  compactIntervalTypes?: IntervalType[];
  compact?: boolean;
  constrainWidth?: boolean;
  fullWidth?: boolean;
}

export const CollapsibleRangeSelector = ({
  rangeProps,
  intervalTypes,
  compactIntervalTypes,
  compact = false,
  constrainWidth = false,
  fullWidth = false,
}: Props) => {
  const collapseSection = useBottomControlsSectionCollapse();

  return (
    <RangeSelector
      maxWidth={constrainWidth ? CONSTRAINED_MAX_WIDTH : undefined}
      compact={compact}
      fullWidth={fullWidth}
      intervalTypes={intervalTypes}
      compactIntervalTypes={compactIntervalTypes}
      intervalType={rangeProps.intervalType}
      range={
        rangeProps.intervalType === "custom" ? rangeProps.range : undefined
      }
      onSelect={(type) => {
        rangeProps.selectInterval(type);
        collapseSection();
      }}
      onCustomSelect={(start, end) => {
        rangeProps.customIntervalSelect(start, end);
        collapseSection();
      }}
    />
  );
};
